import React, { useRef, useState } from 'react'
 

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postEmployeRequests } from '../../../../MyApi/hr/employerequests'


import PageHeader from '../../../../Components/UI/PageHeader'

import AddEmployeRequest from '../../../../Components/hr/employrequests/employrequestsStore/AddPayrolls'


const EmployeRequestsStore = () => {
const [sb_request_id ,setRequestId]= useState("")
const [sb_employe_id , setEmployId] =useState("")
const [date_from , setDateFrom] =useState("")
const [date_to ,setDateTo]= useState("")
const [time_from, setTimeFrom] = useState("")
const [time_to ,setTimeTo] = useState("")
const [image, setImage] = useState('');
const [amount ,setAmount] =useState("")
const [hours_count ,setHoursCount] =useState("")
const [days_count, setDaysCount] = useState("")
const [note ,setNote] = useState("")
const fileImageRef =useRef(null)

 const mutation = useMutation("postEmployRequests" , (postData)=>postEmployeRequests(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setDateFrom("")
        setDateTo("")
        setTimeFrom("")
        setTimeTo("")
        setAmount("")
        setHoursCount("")
        setDaysCount("")
        setNote("")
        fileImageRef.current.value = ""
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    const formData = new FormData()
    formData.append("sb_request_id",sb_request_id)
    formData.append("sb_employe_id", sb_employe_id)
    formData.append("date_from", date_from)
    formData.append("date_to", date_to)
    formData.append("time_from", time_from)
    formData.append("time_to", time_to)
    formData.append("image", image)
    formData.append("amount", amount)
    formData.append("hours_count", hours_count)
    formData.append("days_count", days_count)
    formData.append("note", note)
    mutation.mutate(formData)
 }
 const isDisabled= ()=>{
    return !(sb_request_id && sb_employe_id && date_from && date_to && time_from && time_to && image && amount &&hours_count &&days_count && note)
 }
  return ( 

    <div>
        <PageHeader title="Add Employe Request" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
       <AddEmployeRequest  fileImageRef={fileImageRef}  setRequestId={setRequestId} setNote={setNote}  setEmployId={setEmployId} setHoursCount={setHoursCount}  setAmount={setAmount}  setDateFrom={setDateFrom} setDaysCount={setDaysCount} setTimeTo={setTimeTo} setDateTo={setDateTo} setTimeFrom={setTimeFrom} amount={amount} setImage={setImage}  date_from={date_from} date_to={date_to} time_to={time_to}    time_from={time_from} image={image} hours_count={hours_count} days_count={days_count} note={note} />
    </div>
  )
}

export default  EmployeRequestsStore ;
